// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for AWS Marketplace Management Portal (AWS-MARKETPLACE-MANAGEMENT)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmarketplacemanagementportal.html
 *
 * 2025-02-24T21:48:50.624Z
 */
export enum AwsAwsMarketplaceManagementActions {
  /**
   * Grants permission to view additional seller notification recipients
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  GetAdditionalSellerNotificationRecipients = 'aws-marketplace-management:GetAdditionalSellerNotificationRecipients',
  /**
   * Grants permission to view bank account verification status
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  GetBankAccountVerificationDetails = 'aws-marketplace-management:GetBankAccountVerificationDetails',
  /**
   * Grants permission to view secondary user account verification status
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  GetSecondaryUserVerificationDetails = 'aws-marketplace-management:GetSecondaryUserVerificationDetails',
  /**
   * Grants permission to view account verification status
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  GetSellerVerificationDetails = 'aws-marketplace-management:GetSellerVerificationDetails',
  /**
   * Grants permission to update additional seller notification recipients
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  PutAdditionalSellerNotificationRecipients = 'aws-marketplace-management:PutAdditionalSellerNotificationRecipients',
  /**
   * Grants permission to update bank account verification status
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  PutBankAccountVerificationDetails = 'aws-marketplace-management:PutBankAccountVerificationDetails',
  /**
   * Grants permission to update secondary user account verification status
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  PutSecondaryUserVerificationDetails = 'aws-marketplace-management:PutSecondaryUserVerificationDetails',
  /**
   * Grants permission to update account verification status
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  PutSellerVerificationDetails = 'aws-marketplace-management:PutSellerVerificationDetails',
  /**
   * Allows access to the File Upload page inside the AWS Marketplace Management Por
   * tal
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  uploadFiles = 'aws-marketplace-management:uploadFiles',
  /**
   * Allows access to the Marketing page inside the AWS Marketplace Management Porta
   * l
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  viewMarketing = 'aws-marketplace-management:viewMarketing',
  /**
   * Allows access to the Reports page inside the AWS Marketplace Management Portal
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  viewReports = 'aws-marketplace-management:viewReports',
  /**
   * Allows access to the Settings page inside the AWS Marketplace Management Portal
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  viewSettings = 'aws-marketplace-management:viewSettings',
  /**
   * Allows access to the Customer Support Eligibility page inside the AWS Marketpla
   * ce Management Portal
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/detailed-management-portal-permissions.html#seller-ammp-permissions
   */
  viewSupport = 'aws-marketplace-management:viewSupport',
}
